import bigDecimal from "js-big-decimal";

// 带千分号的金额格式化
export const formatPrettyValue = (numberStr: string) => {
  const formatted = /^[-+]?[0-9]+\.{0,1}[0-9]{0,}$/;
  if (formatted.test(numberStr)) {
    return bigDecimal.getPrettyValue(numberStr, 3, ",");
  }
  return numberStr;
};